const user = {
  state: {
    screenLoading: false,
    userInfo: {},
    userID: '253507',
    orderDetail: {},
    imInfo: {}
  },
  mutations: {
    updateUserInfo (state, userInfo) {
      state.userInfo = userInfo
    },
    updateOrderDetail (state, orderDetail) {
      state.orderDetail = orderDetail
    },
    updateImInfo (state, imInfo) {
      state.imInfo = imInfo
    }
  },
  actions: {
    createOrgUser ({ state, commit }) {
    }
  },
  namespaced: true
};

export default user;
